function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, InjectorHelper, SessionSelectors, ThunkHelper } from 'invision-core';
import values from 'ramda/src/values';
var ACP_ACCOUNT_ID = 5000;
var RETRIEVE_ACSR_CUSTOMER = {
  BEGIN: 'RETRIEVE_CUSTOMER_BEGIN',
  SUCCESS: 'RETRIEVE_CUSTOMER_SUCCESS',
  FAILURE: 'RETRIEVE_CUSTOMER_FAILURE'
};
var retrieveCustomerByExternalReferencePromise = function retrieveCustomerByExternalReferencePromise(dispatch, externalReference) {
  var $ngRedux = InjectorHelper.getNgReduxService();
  var state = $ngRedux.getState();
  return ThunkHelper(dispatch, values(RETRIEVE_ACSR_CUSTOMER), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscriber',
    headers: _defineProperty(_defineProperty(_defineProperty({}, ApiConstants.SUBSCRIBER_EXTERNAL_REFERENCE_HEADER, externalReference), ApiConstants.SUBSCRIBER_EXTERNAL_REFERENCE_TYPE_HEADER, ACP_ACCOUNT_ID), ApiConstants.CUSTOM_SUBSCRIBER_LANGUAGE_HEADER, SessionSelectors.LanguageHeaderSelector(state)),
    data: {}
  });
};
export var retrieveCustomerByExternalReference = function retrieveCustomerByExternalReference(externalReference) {
  return function (dispatch) {
    return retrieveCustomerByExternalReferencePromise(dispatch, externalReference);
  };
};